import { SxProps, Theme } from '@mui/material';

type TStyles = {
  container: SxProps<Theme>;
  inputWrapper: SxProps<Theme>;
  input: SxProps<Theme>;
  copyButton: SxProps<Theme>;
  icon: SxProps<Theme>;
  copyButtonText: SxProps<Theme>;
};

export const styles: TStyles = {
  container: (theme: Theme) => ({
    display: 'flex',
    width: '100%',
    maxWidth: '80%',
    marginTop: theme.spacing(1.75),
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(0.75),
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
    transition: 'border-color 0.2s ease',
    '&:hover': {
      borderColor: theme.palette.grey[500],
    },
  }),
  inputWrapper: {
    flex: 1,
    minWidth: 0,
    px: 1.5,
    py: 1,
  },
  input: {
    width: '100%',
    fontSize: '0.875rem',
    color: 'text.primary',
    '& .MuiInputBase-input': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      padding: 0,
    },
  },
  copyButton: (theme: Theme) => ({
    flexShrink: 0,
    borderLeft: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 0,
    px: 1.5,
    py: 1,
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    textTransform: 'none',
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
    minWidth: 'auto',
  }),
  icon: {
    width: 16,
    height: 16,
    flexShrink: 0,
  },
  copyButtonText: {
    fontSize: '0.875rem',
    lineHeight: 1.2,
  },
};
